import z from 'zod';
import { datetime, entity, string, userPolicies, } from '../common';
import { assetProperties } from './asset';
export var UserType;
(function (UserType) {
    UserType["Default"] = "default";
    UserType["ServiceAccount"] = "serviceAccount";
    UserType["Kiosk"] = "kiosk";
})(UserType || (UserType = {}));
export const user = z.object({
    ...entity.shape,
    username: string,
    name: string,
    properties: assetProperties,
    globalRoles: string.array().default([]),
    specialPermissions: string.array().default([]),
    isServiceAccount: z.boolean().optional(),
    lastActiveAt: datetime.optional(),
    type: z.nativeEnum(UserType).optional(),
    userPolicies: userPolicies.optional(),
});
